<template>
  <div id="configManager">
    仅用于测试
  </div>
</template>

<script>
export default {

}
</script>